import React, { useRef, useState, useEffect } from "react"
import {
  Col,
  Layout,
  Row,
  Typography,
  Input,
  Button,
  Grid,
  Carousel,
  Form,
} from "antd"
import { StaticImage } from "gatsby-plugin-image"
import ElephantFeaturesSection from "./ElephantFeaturesSection"
import Toast from "../../../shared/Components/Toast"
import {
  CoilZinc,
  DottedMaskZinc,
  GreyLeftElephant,
  GreyRightElephant,
} from "../../../assets/images"

require("./landingPageContent.less")

const { useBreakpoint } = Grid
const { Content } = Layout
const { Title } = Typography

const LandingPageContent = props => {
  const breakpoints = useBreakpoint()
  const freeTrailRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    if (props.clickedFreeTrial) {
      freeTrailRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      })
      props.setClickedFreeTrial(false)
    }
  }, [props.clickedFreeTrial])

  const getFreeTrial = async values => {
    try {
      setLoading(true)
      await fetch(`${process.env.REACT_APP_SERVER_URL}sendgrid/landingpage`, {
        body: JSON.stringify({
          subject: "Someone Is Interested In Elephant",
          html: `
                  <div>
                    <div>
                      <span>${values.email} is interested to signup</span>
                    </div>
                  </div>
                `,
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      })
      setLoading(false)
      Toast(
        "Thank you! Your request has been sent to Elephant. Someone will be in touch soon.",
        "success"
      )
      form.resetFields()
    } catch (e) {
      setLoading(false)
      Toast(e.message, "error")
    }
  }

  return (
    <Content style={{ marginTop: 106 }}>
      <Row className="zinc-background">
        <Col xs={24}>
          <Row justify="center" className="mt-20">
            <Col className="coming-soon roundBorder">COMING SOON!</Col>
          </Row>
          <Row justify="center" className="mt-20" gutter={[0, 6]}>
            <Col xs={20} lg={20} xl={16} xxl={13}>
              <Title
                level={1}
                className={`textCenter ${breakpoints.md ? "font-size-56" : ""}`}
              >
                Streamlining The Relationship Between CPAs And Clients
              </Title>
            </Col>
            <Col xs={24}>
              <Row justify="center">
                <Col
                  className={`${
                    breakpoints.md ? "font-size-24" : ""
                  } textCenter subtitle-text`}
                  xs={20}
                  lg={16}
                  xl={11}
                  xxl={9}
                >
                  Elephant is a secure cloud-based practice management solution
                  for small to midsize accounting firms
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col
              className="mt-30"
              style={!breakpoints.md ? { marginTop: -20, marginLeft: -40 } : {}}
            >
              <img
                src={DottedMaskZinc}
                alt=""
                width={breakpoints.xl ? 350 : breakpoints.lg ? 250 : 150}
                height={breakpoints.xl ? 350 : breakpoints.lg ? 250 : 130}
              />
            </Col>
            <Col flex="auto">
              <Row justify="end" style={{ marginTop: "-20px" }}>
                <Col xl={{ pull: 3 }} lg={{ pull: 1 }}>
                  <img
                    src={CoilZinc}
                    alt=""
                    width={breakpoints.lg ? 140 : 100}
                    height={breakpoints.lg ? 140 : 100}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <StaticImage
            src="../../../assets/images/ZincBottomBorder.png"
            style={{ width: "100%", height: 50 }}
            alt=""
          />
        </Col>
      </Row>
      <Row justify="center" className="mb-60">
        <Col
          className="dashboard-image carousel-dots box-shadow-1"
          style={{
            width: breakpoints.lg ? "65%" : breakpoints.md ? "75%" : "95%",
          }}
        >
          <div
            style={{
              marginTop: breakpoints.xl ? -410 : breakpoints.lg ? -310 : -150,
            }}
          >
            <Carousel autoplay={true}>
              <div>
                <StaticImage
                  src="../../../assets/images/FirmDashboard.png"
                  alt="accounting firm practice management - Elephant CPA"
                  placeholder="tracedSVG"
                  layout="constrained"
                />
              </div>
              <div>
                <StaticImage
                  src="../../../assets/images/ManageAccountant.png"
                  alt="accountant management system - Elephant CPA"
                  placeholder="tracedSVG"
                  layout="constrained"
                />
              </div>
              <div>
                <StaticImage
                  src="../../../assets/images/AccountantDashboard.png"
                  alt="accountant workflow practice management - Elephant CPA"
                  placeholder="tracedSVG"
                  layout="constrained"
                />
              </div>
            </Carousel>
          </div>
        </Col>
      </Row>
      <Row ref={freeTrailRef} justify="center" className="mb-30">
        <Col xs={22}>
          <Row className="free-trial-row">
            <Col {...(breakpoints.lg ? {} : { xs: 24 })}>
              <img
                src={GreyLeftElephant}
                alt="grey elephant"
                height={200}
                width={200}
              />
            </Col>
            <Col flex="1 0 50%">
              <Row
                justify="center"
                align="bottom"
                style={breakpoints.lg ? {} : { marginTop: -200 }}
              >
                <Col flex="1 0 50%">
                  <Row
                    className="mt-60"
                    justify="center"
                    style={
                      breakpoints.lg ? {} : { position: "absolute", zIndex: 1 }
                    }
                  >
                    <Col xxl={13} xl={19} lg={24} xs={22}>
                      <Title
                        className={`textCenter ${
                          breakpoints.md ? "font-size-54" : ""
                        }`}
                        level={breakpoints.sm ? 2 : 3}
                      >
                        Would you like a{" "}
                        <span className="parallelogram-shape">
                          free 14-day trial
                        </span>{" "}
                        when Elephant launches? Enter your email below!
                      </Title>
                    </Col>
                    <Col xs={24}>
                      <Row justify="center">
                        <Col
                          xs={22}
                          lg={24}
                          xl={16}
                          xxl={11}
                          className={`${
                            breakpoints.sm
                              ? "get-free-trial-input-sm"
                              : "get-free-trial-input-xs"
                          } mt-30 mb-60`}
                        >
                          <Form form={form} onFinish={getFreeTrial}>
                            <Form.Item
                              name="email"
                              rules={[
                                {
                                  required: true,
                                  type: "email",
                                  message:
                                    "Please enter a valid email address, e.g. name@domain.com",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Enter Your Email"
                                suffix={
                                  <Button
                                    type="primary"
                                    htmlType={"submit"}
                                    loading={loading}
                                  >
                                    Get Free Trial
                                  </Button>
                                }
                              />
                            </Form.Item>
                          </Form>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col {...(breakpoints.lg ? {} : { xs: 24 })}>
                  <Row
                    justify="end"
                    align="bottom"
                    style={
                      breakpoints.lg
                        ? {}
                        : breakpoints.md
                        ? { marginTop: 170 }
                        : breakpoints.sm
                        ? { marginTop: 210 }
                        : { marginTop: 210 }
                    }
                  >
                    <Col>
                      <img
                        src={GreyRightElephant}
                        alt=""
                        height={200}
                        width={200}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="zinc-background wrapper-row-elephant-features">
        <Col xs={24}>
          <ElephantFeaturesSection />
        </Col>
      </Row>
      <Row justify="center" className="practice-management-section-row">
        <Col xs={22} lg={21} xl={22} xxl={20}>
          <Row justify="center">
            <Col className="mt-60" flex="1 0 20%">
              <Title
                className={breakpoints.md ? "" : "textCenter"}
                level={
                  breakpoints.xl ? 1 : breakpoints.md && !breakpoints.lg ? 3 : 2
                }
              >
                <Row ref={props.test}>
                  <Col xs={24}>Total Practice Management,</Col>
                  <Col xs={24}>One Price Per User</Col>
                </Row>
              </Title>
            </Col>
            <Col>
              <StaticImage
                src="../../../assets/images/PeopleWheel.png"
                width={700}
                className="peopleWheel"
                placeholder="tracedSVG"
                alt="Accounting practice management software solution - Elephant CPA"
                style={
                  {
                    /*                   marginTop: breakpoints.xl
                    ? "-80px"
                    : breakpoints.md
                    ? -10
                    : 30, */
                  }
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Content>
  )
}

export default LandingPageContent
